import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop, Vue } from "vue-property-decorator";
import LiquorTree from "liquor-tree";
import Carousel from "vue2-simple-carousel";
import * as _ from "lodash";
// SYSTEM1
import BaseMixer from "@/router/views/BaseMixer";
Vue.use(LiquorTree);
let VueCarousel = /** @class */ (() => {
    let VueCarousel = class VueCarousel extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.currentOffset = 0;
            this.windowSize = 3;
            this.paginationFactor = 33.33;
        }
        //computed
        get atEndOfList() {
            return this.currentOffset <= this.paginationFactor * -1 * (this.teamMembers.length - this.windowSize);
        }
        get atHeadOfList() {
            return this.currentOffset === 0;
        }
        get sortedTeamMembers() {
            return _.sortBy(this.teamMembers, (member) => member.fullName);
        }
        //Methods
        moveCarousel(direction) {
            // Find a more elegant way to express the :style. consider using props to make it truly generic
            if (direction === 1 && !this.atEndOfList) {
                this.currentOffset -= this.paginationFactor;
            }
            else if (direction === -1 && !this.atHeadOfList) {
                this.currentOffset += this.paginationFactor;
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], VueCarousel.prototype, "teamMembers", void 0);
    VueCarousel = __decorate([
        Component({
            name: "VueCarousel",
            components: {
                Carousel,
            },
        })
    ], VueCarousel);
    return VueCarousel;
})();
export default VueCarousel;
